import {
  Announcement02Icon,
  Briefcase02Icon,
  CalendarIcon,
  Cloud01Icon,
  Compass03Icon,
  FaceSmileIcon,
  File05Icon,
  Globe01Icon,
  Hash02Icon,
  HeartIcon,
  Home02Icon,
  Lightbulb02Icon,
  Lock01Icon,
  Mail01Icon,
  Pin02Icon,
  Rocket02Icon,
  Star05Icon,
  Trophy01Icon,
} from '@gohighlevel/ghl-icons/24/outline'
export const icons = [
  { id: 1, iconName: 'FaceSmile', icon: FaceSmileIcon },
  { id: 2, iconName: 'Heart', icon: HeartIcon },
  { id: 3, iconName: 'Globe01', icon: Globe01Icon },
  { id: 4, iconName: 'Home02', icon: Home02Icon },
  { id: 5, iconName: 'Announcement02', icon: Announcement02Icon },
  { id: 6, iconName: 'Calendar', icon: CalendarIcon },
  { id: 7, iconName: 'Rocket02', icon: Rocket02Icon },
  { id: 8, iconName: 'File05', icon: File05Icon },
  { id: 9, iconName: 'Trophy01', icon: Trophy01Icon },
  { id: 10, iconName: 'Briefcase02', icon: Briefcase02Icon },
  { id: 11, iconName: 'Lock01Icon', icon: Lock01Icon },
  { id: 12, iconName: 'Lightbulb02', icon: Lightbulb02Icon },
  { id: 13, iconName: 'Mail01', icon: Mail01Icon },
  { id: 14, iconName: 'Pin02', icon: Pin02Icon },
  { id: 15, iconName: 'Cloud01', icon: Cloud01Icon },
  { id: 16, iconName: 'Star05', icon: Star05Icon },
  { id: 17, iconName: 'Compass03', icon: Compass03Icon },
  { id: 18, iconName: 'Hash02Icon', icon: Hash02Icon },
]
